<script setup lang="ts">
import { ref, toRefs, onBeforeMount, watch } from "vue";
import PieSegmentsDTO = Modules.BookingExperts.Data.PieSegmentsDTO;

const props = withDefaults(
	defineProps<{
		items: PieSegmentsDTO[];
	}>(),
	{}
);

const { items } = toRefs(props);
const highLightedItem = ref();

watch(items, () => {
	if (items.value.length > 0) {
		highLightedItem.value = items.value[0];
	}
});
</script>

<template>
	<v-pie
		class="pa-3 mt-3 justify-center"
		:items="items"
		gap="2"
		inner-cut="70"
		item-key="id"
		rounded="2"
		:legend="{ position: 'right' }"
		animation
		hide-slice
		reveal
	>
		<template v-slot:center>
			<div class="text-center" v-if="highLightedItem">
				<div class="text-h3 text-primary">{{ highLightedItem.value }} %</div>
				<div class="opacity-70 mt-1 mb-n1">{{ highLightedItem.title }}</div>
			</div>
		</template>

		<template v-slot:legend="{ items, toggle, isActive }">
			<v-list
				class="py-0 mb-n5 mb-md-0 bg-transparent"
				density="compact"
				width="300"
			>
				<v-list-item
					v-for="item in items"
					:key="item.key"
					:class="['my-1', { 'opacity-40': !isActive(item) }]"
					:title="item.title"
					rounded="lg"
					link
					@click="toggle(item)"
					@mouseenter="highLightedItem = item"
				>
					<template v-slot:prepend>
						<v-avatar :color="item.color" :size="16"></v-avatar>
					</template>
					<template v-slot:append>
						<div class="font-weight-bold">{{ item.value }}%</div>
					</template>
				</v-list-item>
			</v-list>
		</template>
	</v-pie>
</template>

<style scoped lang="scss"></style>
